// extracted by mini-css-extract-plugin
export default {"wrapper":"Theme_wrapper__QJo6j","select":"Theme_select__d19Gk"};